class VideoHelper {
    /**
     * stop all video players on the page
     * that have not been destroyed
     * @param except
     */
    static stopAll(except = null) {
        const videos = document.querySelectorAll('video:not([loop])');
        if (videos !== null) {
            for (let i = 0; i < videos.length; i += 1) {
                if (videos[i] !== except) {
                    videos[i].pause();
                }
            }
        }

        if (window.youtubePlayers && Object.keys(window.youtubePlayers).length) {
            Object.keys(window.youtubePlayers).forEach((key) => {
                if (key !== except) {
                    window.youtubePlayers[key].pauseVideo();
                }
            });
        }
    }

    static getProgress(currentTime, duration) {
        const progress = currentTime / duration;
        return (progress).toFixed(2) * 100;
    }

    static dataLayerPush(videoAction, progress, videoTitle = '') {
        const dataLayerObject = {
            event: 'video',
            videoTitle,
            videoAction,
            videoProgress: `${progress}%`,
        };

        window.dataLayer.push(dataLayerObject);
    }
}

export default VideoHelper;
